import { B2Card } from "@hdb/biome-2";
import { createRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getUserInfo } from "src/core/auth/auth.service";
import ExecuteActionWithToaster from "src/shared/helpers/executeActionWithToaster";
import { displayToast } from "src/shared/helpers/toaster.helper";
import * as yup from "yup";
import MfaComponent from "../../../../../../core/components/mfa/mfa.component";
import ModalComponent from "../../../../../../core/components/modal/modal.component";
import { AssetCommandEnums } from "../../../../../../core/enums/assetCommands-enums";
import InfoTileContainer from "../../../../../../shared-elements/info-tile/info-tile-container.component";
import InfoTileComponent from "../../../../../../shared-elements/info-tile/info-tile.component";
import { safeAtob } from "../../../../../../shared/helpers/enode-decode-string";
import {
  getAssetByCode,
  getAssetSensorInfo,
  getDetectionRanges,
  getMotionSensor,
  getPhotoSensor,
  sendGetCommandToDms,
  setMotionSensor,
  setPhotoSensor,
} from "../../../../../../store/slices/asset.slice";
import { setOtpIsValidation } from "../../../../../../store/slices/mfa-otp.slice";
import AssetActionFormComponent, {
  AssetActioFormConfig,
} from "./asset-action-form.component";

const SensorParameterCommonComponent = () => {
  const motionSensorFormRef = createRef();
  const photoSensorFormRef = createRef();
  // const rainSensorFormRef = createRef();
  const dispatch = useDispatch();
  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;
  const [detectionRangeOptions, setDetectionRangeOptions] = useState([]);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState<boolean>(false);
  const [activeForm, setActiveForm] = useState<string>("");

  const mfaInfo = useSelector((state: any) => {
    return state.user.mfaInfo;
  });

  const user = getUserInfo();

  // const connectSocket = () => {
  //   const sensorParameterClient = new W3CWebSocket(
  //     `${process.env.REACT_APP_WS_BASE_URL}/slpapp/push?name=sensor-parameter`
  //   );

  //   sensorParameterClient.onopen = () => {
  //     console.log("WebSocket Sensor Parameter Client Connected");

  //     setSocketStatus("open");
  //     sensorParameterClient.send(
  //       JSON.stringify({ token: new Date().getUTCMilliseconds() })
  //     );
  //     setRetryCount(0);
  //   };

  //   sensorParameterClient.onmessage = (message) => {
  //     const data = JSON.parse(`${message.data}`);
  //     const user = getUserInfo();
  //     if (
  //       user.email.toLowerCase() === data.NotificationIdentifier.toLowerCase()
  //     ) {
  //       toast.success("Acknowledgement Received", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: false,
  //         pauseOnFocusLoss: true,
  //         draggable: true,
  //         pauseOnHover: true,
  //       });
  //     }

  //     setAssetRealTimeConfigDataForSensorParameter(data);
  //   };

  //   sensorParameterClient.onclose = (event) => {
  //     console.log("WebSocket Sensor Parameter Closed", event);

  //     setSocketStatus("closed");
  //     setIsCallRetry((prev: boolean) => !prev);
  //   };

  //   setSocket(sensorParameterClient);
  // };

  // useEffect(() => {
  //   setRetryCount((current: number) => current + 1);

  //   if (socketStatus == "initial") {
  //     connectSocket();
  //   } else if (socketStatus == "closed") {
  //     if (retryCount < WEBSOCKET_MAX_RETRY_COUNT) {
  //       setTimeout(() => {
  //         console.log(
  //           `Sensor Parameter Retry Attempts ${retryCount}/${WEBSOCKET_MAX_RETRY_COUNT}}`
  //         );

  //         connectSocket();
  //       }, 5000);
  //     } else {
  //       console.log(
  //         `Maximum retry attempts reached for Sensor Parameter WebSocket`
  //       );
  //     }
  //   }

  //   return () => {
  //     if (socket && socket.readyState === socket.OPEN) {
  //       socket.close();
  //       console.log("Sensor Parameter Client socket closed");
  //     }
  //   };
  // }, [socketStatus, isCallRetry]);

  useEffect(() => {
    dispatch(getDetectionRanges());
    dispatch(getMotionSensor({ id }));
    dispatch(getPhotoSensor({ id }));
    // dispatch(getRainSensor({ id }));
  }, [dispatch]);

  const [motionSensorFormInitialValues, setMotionSensorFormInitialValues] =
    useState({
      detectionRangeId: "",
    });

  const [photoSensorFormInitialValues, setPhotoSensorFormInitialValues] =
    useState({
      photoLowerThreshold: "",
      photoUpperThreshold: "",
      photoSensing: false,
    } as any);

  const motionSensorData = useSelector((state: any) => {
    return state.asset.motionSensor;
  });

  const [isLoadingMotionSensor, setIsLoadingMotionSensor] = useState(false);

  const photoSensorData = useSelector((state: any) => {
    return state.asset.photoSensor;
  });

  const [isLoadingPhotoSensor, setIsLoadingPhotoSensor] = useState(false);

  const socketData = useSelector((state: any) => {
    return state.asset.socketData;
  });

  // const rainSensorData = useSelector((state: any) => {
  //   return state.asset.rainSensor;
  // });

  // const isLoadingRainSensor = useSelector((state: any) => {
  //   return state.asset.isLoadingRainSensor;
  // });

  const assetDetails = useSelector((state: any) => {
    return state.asset.assetDetails;
  });

  const isLoadingAssetDetails = useSelector((state: any) => {
    return state.asset.isLoadingAssetDetails;
  });

  /*   const sensorParameters = useSelector((state: any) => {
      return state.asset.sensorParameters;
    }); */

  const detectionRangeResponse = useSelector((state: any) => {
    return state.asset.detectionRanges;
  });

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const socketRealTimeUpdate = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdate;
  });

  const socketRealTimeUpdateData = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdateData;
  });

  /*   const assetSensorInfo = useSelector((state: any) => {
      return state.asset.assetSensorInfo;
    });
    const isLoadingAssetSensorInfo = useSelector((state: any) => {
      return state.asset.isLoadingAssetSensorInfo;
    }); */

  /*   const assetRealTimeConfigDataForSensorParameter = useSelector(
    (state: any) => {
      return state.asset.assetRealTimeConfigDataForSensorParameter;
    }
  ); */

  useEffect(() => {
    setIsLoadingMotionSensor(true);

    const data: any = {
      assetCode: id,
      detectionRangeId: Number.parseInt(motionSensorData?.detectionRangeId) || "",
      isAcknowledged: false,
    };

    setMotionSensorFormInitialValues(data);
  }, [motionSensorData]);

  useEffect(() => {
    setIsLoadingMotionSensor(false);
  }, [motionSensorFormInitialValues]);

  useEffect(() => {
    if (photoSensorData && Object.keys(photoSensorData).length) {
      setIsLoadingPhotoSensor(true);
      const data: any = {
        assetCode: id,
        photoLowerThreshold:
          Number.parseInt(photoSensorData?.photoLowerThreshold) || "",
        photoUpperThreshold:
          Number.parseInt(photoSensorData?.photoUpperThreshold) || "",
        photoSensing: photoSensorData?.photoSensing || false,
        isAcknowledged: false,
      };

      setPhotoSensorFormInitialValues(data);
    }
  }, [photoSensorData]);

  useEffect(() => {
    setIsLoadingPhotoSensor(false);
  }, [photoSensorFormInitialValues]);

  // useEffect(() => {
  //   const data: any = {
  //     assetCode: id,
  //     rainLowerThreshold: Number.parseInt(rainSensorData?.rainLowerThreshold) || "",
  //     rainUpperThreshold: Number.parseInt(rainSensorData?.rainUpperThreshold) || "",
  //     rainSensing: rainSensorData?.rainSensing || false,
  //     isAcknowledged: false,
  //   };

  //   setRainSensorFormInitialValues(data);
  // }, [rainSensorData]);

  useEffect(() => {
    const modes = detectionRangeResponse?.data?.map((detectionRange: any) => ({
      value: detectionRange?.id,
      label: detectionRange?.name,
    }));

    setDetectionRangeOptions(modes);
  }, [detectionRangeResponse]);

  // const [rainSensorFormInitialValues, setRainSensorFormInitialValues] =
  //   useState({
  //     rainLowerThreshold: "",
  //     rainUpperThreshold: "",
  //     rainSensing: false,
  //   } as any);

  const onSubmitMfa = () => {
    switch (activeForm) {
      case "motion-sensor":
        ExecuteActionWithToaster(
          dispatch,
          setMotionSensor({ body: motionSensorFormInitialValues })
        ).then(() => {
          setIsOTPModalOpen(false);
        });

        break;

      case "photo-sensor":
        ExecuteActionWithToaster(
          dispatch,
          setPhotoSensor({ body: photoSensorFormInitialValues })
        ).then((r: any) => {
          setIsOTPModalOpen(false);
        });
        break;

      // case "rain-sensor":
      //   dispatch(setRainSensor({ body: rainSensorFormInitialValues })).then(
      //     (r: any) => {
      //       setIsOtpModalOpen(false);
      //     }
      //   );
      //   break;

      default:
        break;
    }
    dispatch(setOtpIsValidation(false));
  };

  const handleCloseModal = () => {
    setIsOTPModalOpen(false);
  };

  const onSubmitMotionSensor = () => {
    // debugger;
    const form: any = motionSensorFormRef.current;
    let data: any = {};

    if (form) {
      form.handleSubmit();

      data = {
        assetCode: id,
        detectionRangeId: Number.parseInt(form.values.detectionRangeId),
        isAcknowledged: true,
      };

      if (!data.detectionRangeId) {
        return;
      }

      setMotionSensorFormInitialValues(data);
    }

    setActiveForm("motion-sensor");

    if (mfaInfo?.isDMSMfaEnabled) {
      setIsOTPModalOpen(true);
    } else {
      // onSubmitMfa();
      ExecuteActionWithToaster(dispatch, setMotionSensor({ body: data })).then(
        () => {
          setIsOTPModalOpen(false);
        }
      );
    }
  };

  const onSubmitPhotoSensor = () => {
    const form: any = photoSensorFormRef.current;
    let data: any = {};

    if (form) {
      form.handleSubmit();

      data = {
        assetCode: id,
        photoLowerThreshold: Number.parseInt(form.values.photoLowerThreshold),
        photoUpperThreshold: Number.parseInt(form.values.photoUpperThreshold),
        photoSensing: form.values.photoSensing,
        isAcknowledged: true,
      };

      if (
        !data.photoLowerThreshold ||
        !data.photoUpperThreshold ||
        data.photoLowerThreshold > 10000 ||
        data.photoUpperThreshold > 10000 ||
        data.photoLowerThreshold < 0 ||
        data.photoUpperThreshold < 0 ||
        data.photoLowerThreshold >= data.photoUpperThreshold
      ) {
        return;
      }

      setPhotoSensorFormInitialValues(data);
    }

    setActiveForm("photo-sensor");

    if (mfaInfo?.isDMSMfaEnabled) {
      setIsOTPModalOpen(true);
    } else {
      // onSubmitMfa();

      ExecuteActionWithToaster(dispatch, setPhotoSensor({ body: data })).then(
        (r: any) => {
          setIsOTPModalOpen(false);
        }
      );
    }
  };

  // const onSubmitRainSensor = () => {
  //   const form: any = rainSensorFormRef.current;
  //   if (form) {
  //     form.handleSubmit();

  //     const data: any = {
  //       assetCode: id,
  //       rainLowerThreshold: Number.parseInt(form.values.rainLowerThreshold),
  //       rainUpperThreshold: Number.parseInt(form.values.rainUpperThreshold),
  //       rainSensing: form.values.rainSensing,
  //       isAcknowledged: true,
  //     };

  //     if (
  //       !data.rainLowerThreshold ||
  //       !data.rainUpperThreshold ||
  //       data.rainLowerThreshold > 255 ||
  //       data.rainUpperThreshold < 5
  //     ) {
  //       return;
  //     }

  //     setRainSensorFormInitialValues(data);
  //   }

  //   setActiveForm("rain-sensor");

  //   if (mfaInfo?.isDMSMfaEnabled) {
  //     setIsOtpModalOpen(true);
  //   } else {
  //     onSubmitMfa();
  //   }
  // };

  const onCancelClickMotionSensor = () => {
    const form: any = motionSensorFormRef.current;
    form.resetForm();
  };
  const onCancelClickPhotoSensor = () => {
    const form: any = photoSensorFormRef.current;
    form.resetForm();
  };
  // const onCancelClickRainSensor = () => {
  //   const form: any = rainSensorFormRef.current;
  //   form.resetForm();
  // };

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfa,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const photoSensorActionConfig: any = [
    {
      label: "Cancel",
      event: onCancelClickPhotoSensor,
      variant: "secondary",
      moduleName: "Sensor Parameter",
      actionName: "Edit-Sensor Parameter",
    },
    {
      label: "Save",
      event: onSubmitPhotoSensor,
      variant: "primary",
      moduleName: "Sensor Parameter",
      actionName: "Edit-Sensor Parameter",
    },
  ];

  // const rainSensorActionConfig: any = [
  //   {
  //     label: "Cancel",
  //     event: onCancelClickRainSensor,
  //     variant: "secondary",
  //     moduleName: "Sensor Parameter",
  //     actionName: "Edit-Sensor Parameter",
  //   },
  //   {
  //     label: "Save",
  //     event: onSubmitRainSensor,
  //     variant: "primary",
  //     moduleName: "Sensor Parameter",
  //     actionName: "Edit-Sensor Parameter",
  //   },
  // ];

  const motionSensorActionConfig: any = [
    {
      label: "Cancel",
      event: onCancelClickMotionSensor,
      variant: "secondary",
      moduleName: "Sensor Parameter",
      actionName: "Edit-Sensor Parameter",
    },
    {
      label: "Save",
      event: onSubmitMotionSensor,
      variant: "primary",
      moduleName: "Sensor Parameter",
      actionName: "Edit-Sensor Parameter",
    },
  ];

  const onRefreshClickMotionSensor = () => {
    dispatch(getMotionSensor({ id }));
    ExecuteActionWithToaster(
      dispatch,
      sendGetCommandToDms({
        assetCode: id,
        module: Number(AssetCommandEnums.getMotionSensitivity),
      })
    );
  };

  const onRefreshClickPhotoSensor = () => {
    dispatch(getPhotoSensor({ id }));
    ExecuteActionWithToaster(
      dispatch,
      sendGetCommandToDms({
        assetCode: id,
        module: Number(AssetCommandEnums.getPhotoSensing),
      })
    );
  };

  // const onRefreshClickRainSensor = () => {
  //   dispatch(getRainSensor({ id }));
  //   dispatch(
  //     sendGetCommandToDms({
  //       assetCode: id,
  //       module: Number(AssetCommandEnums.getRainSensing),
  //     })
  //   );
  // };

  const motionSensorRefeshActionConfig: any = [
    {
      label: "Refesh",
      event: onRefreshClickMotionSensor,
      variant: "default",
    },
  ];

  const photoSensorRefeshActionConfig: any = [
    {
      label: "Refesh",
      event: onRefreshClickPhotoSensor,
      variant: "default",
    },
  ];

  // const rainSensorRefeshActionConfig: any = [
  //   {
  //     label: "Refesh",
  //     event: onRefreshClickRainSensor,
  //     variant: "default",
  //   },
  // ];

  const motionSensorFormConfig: AssetActioFormConfig = {
    controls: [
      {
        label: "Motion Sensor",
        isGrid: false,
        controlGroup: [
          {
            name: "detectionRangeId",
            label: "Detection Range",
            placeholder: "Select Detection Range",
            type: "select",
            options: detectionRangeOptions,
            required: true,
          },
          /* {
            name: "motionSensing",
            label: "Motion Sensing",
            type: "switch",
            required: true,
          }, */
        ],
      },
    ],
  };

  const motionSensorFormValidationSchema = yup.object().shape({
    detectionRangeId: yup.string().required("Detection range ID is required"),
  });

  const photoSensorFormConfig: AssetActioFormConfig = {
    controls: [
      {
        label: "Photo Sensor",
        isGrid: false,
        controlGroup: [
          {
            name: "photoLowerThreshold",
            label: "Lower Threshold(to detect dim daylight)",
            placeholder: "e.g: 500",
            type: "number",
            suffix: "lux",
            required: true,
          },
          {
            name: "photoUpperThreshold",
            label: "Upper Threshold(to detect bright daylight)",
            placeholder: "e.g: 500",
            type: "number",
            suffix: "lux",
            required: true,
          },
          {
            name: "photoSensing",
            label: "Photo Sensing",
            type: "switch",
            required: false,
          },
        ],
      },
    ],
  };

  const photoSensorFormValidationSchema = yup.object().shape({
    photoLowerThreshold: yup
      .number()
      .required("Photo sensor model lower threshold is required")
      .min(0, "Lower Threshold must be at least 0")
      .max(10000, "Lower Threshold must be at most 10,000"),
    photoUpperThreshold: yup
      .number()
      .required("Photo sensor model upper threshold is required")
      .min(0, "Upper Threshold must be at least 0")
      .max(10000, "Upper Threshold must be at most 10,000")
      .test(
        "is-greater",
        "Upper Threshold must be greater than Lower Threshold",
        function (value, context) {
          const { photoLowerThreshold } = context?.parent || {};
          return value > photoLowerThreshold;
        }
      ),
  });

  // const rainSensorFormConfig: AssetActioFormConfig = {
  //   controls: [
  //     {
  //       label: "Rain Sensor",
  //       isGrid: false,
  //       controlGroup: [
  //         {
  //           name: "rainLowerThreshold",
  //           label: "Lower Threshold(to detect light rain)",
  //           placeholder: "e.g: 200",
  //           type: "number",
  //           suffix: "pulse",
  //           required: true,
  //         },
  //         {
  //           name: "rainUpperThreshold",
  //           label: "Upper Threshold(to detect heavy rain)",
  //           placeholder: "e.g: 200",
  //           type: "number",
  //           suffix: "pulse",
  //           required: true,
  //         },
  //         {
  //           name: "rainSensing",
  //           label: "Rain Sensing",
  //           type: "switch",
  //           required: false,
  //         },
  //       ],
  //     },
  //   ],
  // };

  // const rainSensorModellowerThresholdValidationSchema = yup.object().shape({
  //   rainLowerThreshold: yup
  //     .number()
  //     .required("Rain sensor model lower threshold is required")
  //     .min(5)
  //     .max(255),
  //   rainUpperThreshold: yup
  //     .number()
  //     .required("Rain sensor model upper threshold is required")
  //     .min(5)
  //     .max(255),
  // });

  useEffect(() => {
    if (!id) return;
    dispatch(getAssetByCode({ id }));
    // dispatch(getAssetSensorParameters({ id }));
    dispatch(getAssetSensorInfo({ assetCode: id }));
  }, [id]);

  // useEffect(() => {
  //   if (
  //     sensorParameters &&
  //     Object.keys(sensorParameters)?.length &&
  //     typeof sensorParameters === "object"
  //   ) {
  //     const data = {
  //       detectionRangeId: sensorParameters.motionSensorModel.detectionRangeId,
  //       photoSensorModellowerThreshold:
  //         sensorParameters.photoSensorModel.lowerThreshold,
  //       photoSensorModelupperThreshold:
  //         sensorParameters.photoSensorModel.upperThreshold,
  //       rainSensorModellowerThreshold:
  //         sensorParameters.rainSensorModel.lowerThreshold,
  //       rainSensorModelupperThreshold:
  //         sensorParameters.rainSensorModel.upperThreshold,
  //     };

  //     //setFormInitialValues(data);
  //   }
  // }, [sensorParameters]);

  const showToaster = (socketRealTimeUpdateData: any) => {
    if (
      user[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ] === socketData?.NotificationIdentifier
    ) {
      displayToast(
        socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
        socketRealTimeUpdateData?.ToasterColor
      );
    }
  };

  useEffect(() => {
    const copiedSocketRealTimeUpdate = structuredClone(socketRealTimeUpdate);

    if (copiedSocketRealTimeUpdate.MotionSensor) {
      showToaster(socketRealTimeUpdateData);
      dispatch(getMotionSensor({ id }));
    } else if (copiedSocketRealTimeUpdate.PhotoSensing) {
      showToaster(socketRealTimeUpdateData);
      dispatch(getPhotoSensor({ id }));
    }
    // else if (copiedSocketRealTimeUpdate.rainSensor) {
    //   dispatch(getRainSensor({ id }));
    // }
  }, [socketRealTimeUpdate]); // socketRealTimeUpdateData

  return (
    <>
      <Helmet>
        <title>Sensor Parameter | Asset</title>
      </Helmet>
      <div>
        <div className="asset-details">
          <InfoTileContainer header="Asset Details">
            <InfoTileComponent
              title="Asset ID"
              value={assetDetails.assetId}
              valueWidth={3}
              isLoading={isLoadingAssetDetails}
            />
            <InfoTileComponent
              title="Display Name"
              value={assetDetails?.sensorDisplayName}
              valueWidth={3}
              isLoading={isLoadingAssetDetails}
            />
            <InfoTileComponent
              title="Asset Type"
              value={assetDetails.assetType}
              isLoading={isLoadingAssetDetails}
            />
          </InfoTileContainer>

          <InfoTileContainer header="Location Details">
            <InfoTileComponent
              title="Town Council"
              value={assetDetails?.townCouncil}
              isLoading={isLoadingAssetDetails}
            />
            <InfoTileComponent
              title="Address"
              value={assetDetails?.address}
              isLoading={isLoadingAssetDetails}
            />
            <InfoTileComponent
              title="Level"
              value={assetDetails?.floor}
              isLoading={isLoadingAssetDetails}
            />
          </InfoTileContainer>
        </div>

        <div className="asset-conf-wrapper-sensor mt-4">

          <B2Card className="card-bg">
            <AssetActionFormComponent
              formRef={motionSensorFormRef}
              initialValues={motionSensorFormInitialValues}
              formConfig={motionSensorFormConfig}
              actionConfig={motionSensorActionConfig}
              refreshActionConfig={motionSensorRefeshActionConfig}
              isLoadingData={isLoadingMotionSensor}
              validation={motionSensorFormValidationSchema}
              moduleName={"Sensor Parameter"}
              actionName={"Edit-Sensor Parameter"}
            />
          </B2Card>

          <B2Card className="card-bg">
            <AssetActionFormComponent
              formRef={photoSensorFormRef}
              initialValues={photoSensorFormInitialValues}
              formConfig={photoSensorFormConfig}
              actionConfig={photoSensorActionConfig}
              refreshActionConfig={photoSensorRefeshActionConfig}
              isLoadingData={isLoadingPhotoSensor}
              validation={photoSensorFormValidationSchema}
              moduleName={"Sensor Parameter"}
              actionName={"Edit-Sensor Parameter"}
            />
          </B2Card>

          {/* {assetSensorInfo?.isRainSensor ? (
            <B2Card className="card-bg">
              <AssetActionFormComponent
                formRef={rainSensorFormRef}
                initialValues={rainSensorFormInitialValues}
                formConfig={rainSensorFormConfig}
                actionConfig={rainSensorActionConfig}
                refreshActionConfig={rainSensorRefeshActionConfig}
                isLoadingData={isLoadingRainSensor}
                validation={rainSensorModellowerThresholdValidationSchema}
                moduleName={"Sensor Parameter"}
                actionName={"Edit-Sensor Parameter"}
              />
            </B2Card>
          ) : null} */}

          {isOTPModalOpen && (
            <ModalComponent
              showModal={isOTPModalOpen}
              handleClose={handleCloseModal}
              actionConfig={mfaActionConfig}
              headerTitle={"Multi Factor Authentication"}
              isViewMode={false}
            >
              <MfaComponent />
            </ModalComponent>
          )}
        </div>
      </div>
    </>
  );
};

export default SensorParameterCommonComponent;
